import React from "react";
import { useRef } from 'react';
import httpClient from '../../../services/httpClient'

const FooterButton = ({ lawFirm, setLawFirm, selectedOfficeId, accountNumber, setAccountNumber, sortCode, setSortCode, match, updateMatch, setPdfLink, userName, loggedInLawFirmName, setHideValidationAccountNumber, setHideValidationSortCode, setMatchesPreviousBankDetails }) => {

    let btnChck = useRef();
    let btnSrch = useRef();

    const handleStartNewSearch = async (event) => {
        updateMatch('');
        setLawFirm(null);
        setAccountNumber('');
        setSortCode('');
        setPdfLink(null);
        setMatchesPreviousBankDetails(false);
        setHideValidationAccountNumber(true);
        setHideValidationSortCode(true);
        let inputs = document.querySelectorAll('input');
        inputs.forEach(input => {
            if (input.id !== "users-law-firm") {
                input.value = '';
            }
        });
    }

    const handleCheckDetailsClick = async (event) => {
        let response = null;
        try {
            if (accountNumber.length !== 8) {
                setHideValidationAccountNumber(false);
                let element = document.getElementById("account-number");
                element.classList.add("border-danger");
            } else {
                setHideValidationAccountNumber(true);
                let element = document.getElementById("account-number");
                element.classList.remove("border-danger");
            }
            if (sortCode.length !== 8) {
                setHideValidationSortCode(false);
                let element = document.getElementById("sort-code");
                element.classList.add("border-danger");
            } else {
                setHideValidationSortCode(true);
                let element = document.getElementById("sort-code");
                element.classList.remove("border-danger");
            }
            if (accountNumber.length === 8 && sortCode.length === 8) {
                if (btnChck.current) {
                    btnChck.current.setAttribute("disabled", "disabled");
                }
                if (btnSrch.current) {
                    btnSrch.current.setAttribute("disabled", "disabled");
                }
                const domain = window.location.host;
                let configs = require('../../../config.json');
                const config = configs.filter(c => c.Domain.toLowerCase() === domain.toLowerCase())[0];
                httpClient.defaults.headers.common['Username'] = userName;
                httpClient.defaults.headers.common["Account-Number"] = accountNumber;
                httpClient.defaults.headers.common["Sort-Code"] = sortCode;
                httpClient.defaults.headers.common["Users-Law-Firm"] = loggedInLawFirmName;
                httpClient.defaults.headers.common["Users-Law-Firm-Reference"] = "";
                httpClient.defaults.headers.common['Office-Id'] = selectedOfficeId ?? -1;
                response = await httpClient.get(config.FunctionAppUrl + "/lawfirms/" + lawFirm.id);
                setPdfLink(response.pdfLink);
                setMatchesPreviousBankDetails(response.lawFirm.matchesPreviousBankDetails);
                updateMatch(response.resultType);
            }
        } catch (e) {
            updateMatch(
                'Something went wrong, please try again. If you continue to experience the same issues, please contact the team on 0343 221 0610');
            if (e && e.response) {
                if (e.response.status === 404) {
                    //404 status code means transient Id from the original search has expired. We want to display a specific message for this error scenario
                    updateMatch('Your Session has timed out. You will need to start a new search');
                } else if (e.response.status === 400 &&
                    e.response.data[0] ===
                    "We are unable to verify these details at this time, please try again later.") {
                    //the law firm which was bank account checked is "under review", so for this scenario we need to display a different message.
                    updateMatch('We are unable to verify these details at this time, please try again later.');
                }
                if (e && e.response && e.response.data && e.response.data.errors) {
                    if (e.response.data.errors.length >= 1) {
                        updateMatch(e.response.data.errors[0]);
                    }
                }
            }

            setPdfLink(null);
            setMatchesPreviousBankDetails(false);
        } finally {
            if (btnChck.current) {
                btnChck.current.removeAttribute("disabled");
            }
            if (btnSrch.current) {
                btnSrch.current.removeAttribute("disabled");
            }
        }
    }


    return (
        <div data-testid="footer-button">
            {lawFirm !== null ?
                (<>
                    <div className="row mt-4 mb-4">
                        <div className="col-12 text-danger">
                            {match !== 'No Match' && match !== 'Match' && match !== 'Match with Cautions'
                                ? (<>{match}</>) : (null)}
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-2">
                            <button ref={btnSrch} type="button" className="w-100 fs-6 btn btn-outline-dark mr-2 ml-2" onClick={handleStartNewSearch}>START A NEW SEARCH</button>
                        </div>
                        <div data-testid="div-check-details" className="col-2 mb-4">
                            {match !== 'No Match' && match !== 'Match' && match !== 'Match with Cautions'
                                ? (<button data-testid="btn-check-details" ref={btnChck} type="button" className="w-100 fs-6 btn btn-dark mr-2 ml-2" onClick={handleCheckDetailsClick}>CHECK DETAILS</button>) : (null)}
                        </div>
                        <div className="mt-4">
                            <p>confirmly Product Terms and Conditions can be viewed by clicking <a href='https://cloud.lms.com/consent' className='link-dark' target="_blank" rel="noreferrer">here</a>.</p>
                        </div>
                    </div>
                </>) : (null)
            }
        </div>
    );
}

export default FooterButton